// A module is reached through a token, never through its implementation.
// The interface says what the module does; the token, with the same name,
// is how another module or the container asks for it.

export type ModuleApiToken<TApi, TId extends string = string> = {
  readonly kind: "module-api";
  readonly id: TId;
  /** Phantom: carries the Api type so `create()` receives it typed. Never set. */
  readonly api?: TApi;
};

/** The Api a token stands for. */
export type ApiOf<TToken> = TToken extends ModuleApiToken<infer TApi> ? TApi : never;

/**
 * Declares the token for a module Api.
 *
 * export interface WaitlistApi { join(input: JoinInput): Promise<Entry> }
 * export const WaitlistApi = moduleApi<WaitlistApi>()("waitlist");
 */
export function moduleApi<TApi>() {
  return <const TId extends string>(id: TId): ModuleApiToken<TApi, TId> =>
    Object.freeze({ kind: "module-api", id });
}
